'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import classNames from 'classnames';
var UIDialogBody = forwardRef(function (_ref, ref) {
  var className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["className"]);

  return React.createElement("div", Object.assign({
    ref: ref
  }, rest, {
    className: classNames("uiDialogBody private-modal__body has--vertical-spacing", className)
  }));
});
UIDialogBody.propTypes = {
  children: PropTypes.node
};
UIDialogBody.displayName = 'UIDialogBody';
export default UIDialogBody;